import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { WsButton, WsDialog, WsTypography, WsTypoVariants } from 'wisestep-base';

import IconForDialog from '../iconForDialog';

export interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deletingItem?: string;
}
const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  deletingItem = 'item',
}) => (
  <WsDialog openDialog={open} onClose={onClose}>
    <DialogTitle>
      <IconForDialog icon={<DeleteForeverIcon />} />
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        <WsTypography variant={WsTypoVariants.SUB_TITLE}>
          {`Are you sure you want to delete "${deletingItem}" ?`}
        </WsTypography>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <WsButton onClick={onClose} variant="outlined">
        Cancel
      </WsButton>
      <WsButton onClick={onConfirm}>Proceed</WsButton>
    </DialogActions>
  </WsDialog>
);

export default ConfirmDeleteDialog;
